import React, { useState } from "react";

import { map } from "lodash/fp";

import ScrollSlider from "@app/analytics/components/ScrollSlider";
import useRecordingInfoQueries from "@app/analytics/hooks/recordings/useRecordingInfoQueries";
import { useGetRecordingStatus } from "@app/analytics/hooks/recordings/useRecordingStatus";
import Clip from "@app/analytics/Pulse/components/Clip";
import ClipPlaylist from "@app/analytics/Pulse/components/Clip/ClipPlaylist";
import { PulseClip, PulseTopicClip } from "@app/analytics/Pulse/types";
import * as Events from "@app/analytics/tracking/events";

const TopicsTableClips = ({ clips }: { clips: PulseTopicClip[] }) => {
  const [playingClipId, setPlayingClipId] = useState<PulseClip["id"] | null>(
    null
  );

  const getRecordingStatus = useGetRecordingStatus();

  const sessionIds = map("sessionId", clips);

  // for each unique session id, get recording info and combine clips with the recording info
  const recordingInfoQueries = useRecordingInfoQueries(sessionIds);

  const handlePlayClip = (clipId: string) => {
    Events.clickClip({ context: "in_topic" });
    setPlayingClipId(clipId);
  };

  const viewableClips = clips.filter((clip) => {
    const { status } = getRecordingStatus(
      recordingInfoQueries.get(clip.sessionId)
    );
    return status === "available";
  });

  const showPlaylist = viewableClips.length > 0;

  return (
    <ScrollSlider>
      {showPlaylist && (
        <ClipPlaylist
          clips={viewableClips}
          recordingInfo={recordingInfoQueries}
        />
      )}
      {clips.map((clip, i) => {
        const { isLoading, recordingInfo } =
          recordingInfoQueries.get(clip.sessionId) ?? {};
        return (
          <Clip
            key={clip.id}
            clip={clip}
            forcePause={playingClipId != null && playingClipId !== clip.id}
            isLoading={isLoading}
            recordingInfo={recordingInfo}
            onPlay={handlePlayClip}
            sx={{
              pl: !showPlaylist && i === 0 ? 3 : 0,
              pr: i === clips.length - 1 ? 1 : 0,
            }}
          />
        );
      })}
    </ScrollSlider>
  );
};

export default TopicsTableClips;
